import { Button, Col, Divider, Row, Space, Statistic, StatisticProps } from "antd";
import { forwardRef, useEffect, useState } from "react";
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import Server from "../../../server/Server";
import URL from "../../../server/URL";

const YearOrderCount = forwardRef((props: any, ref: any) => {
    const [days, setDays] = useState<number>(0)
    const [data, setData] = useState<any>(null);

    useEffect(() => {
        onLoad();
    }, [days])

    const onLoad = () => {
        var request = {
            days: days
        }
        Server.Post(URL.YearOrder.GetYearOrderCount, request, false).then((response: any) => {
            if (response.isSuccess) {
                setData(response);
            }
        })
    }

    return <div>
        <div style={{
            backgroundColor: '#fafafa', borderBottom: '1px solid #e7e7eb'
            , position: 'fixed', top: 0, zIndex: '999', width: '100%', height: '35px'
        }}>
            <span style={{ lineHeight: '32px', fontWeight: 'bold', margin: '5px' }}>
                年单日数据统计
            </span>
            <Space size={1} style={{ float: 'right', margin: '2px', lineHeight: '32px' }} split={<Divider type='vertical' />}>
                <Button type={days != 0 ? "link" : "text"} size={'small'} onClick={() => { setDays(0); }}>今日</Button>
                <Button type={days != 1 ? "link" : "text"} size={'small'} onClick={() => { setDays(1); }}>本周</Button>
                <Button type={days != 2 ? "link" : "text"} size={'small'} onClick={() => { setDays(2); }}>本月</Button>
            </Space>
        </div>
        <div style={{ marginTop: '35px', height: 'calc(100% - 35px)', overflow: 'auto' }}>
            <Row gutter={24} style={{ width: '100%', padding: '20px' }}>
                <Col span={6} >
                    <Statistic title="有效出单(票)" value={data?.totalCount ?? 0} />
                </Col>
                <Col span={6} >
                    <Statistic title="保费合计(元)" value={data?.totalAmount ?? 0} precision={2} />
                </Col>
                <Col span={6} >
                    <Statistic title="毛利合计(元)" value={data?.profitAmount ?? 0} precision={2} />
                </Col>
                <Col span={6} >
                    <Statistic title="投保业务员(个)" value={data?.totalSales ?? 0} />
                </Col>
            </Row>
        </div>
    </div>
})
export default YearOrderCount;